import * as React from 'react';

/**
 * @deprecated Prefer a Pantry component instead. See https://docs.tocktix.com/pantry.
 * If an equivalent component doesn't exist yet, reach out in #pantry-design-system on Slack.
 */
const SvgIconRadiobuttonUnchecked = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={18} height={18} fill="none" {...props}>
    <circle cx={9} cy={9} r={8.5} stroke="currentColor" />
  </svg>
);

export default SvgIconRadiobuttonUnchecked;
